// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSensorySessionId } from './FoodSensorySession';
import { operatorId } from './Operator';
import { foodSensoryAnalystStatus } from './FoodSensoryAnalystStatus';
import { foodTasterId } from './FoodTaster';
import { z } from 'zod';
export const foodSensoryAnalystId = (z.number());
export const foodSensoryAnalyst = z.object({
    id: foodSensoryAnalystId,
    sensory_session_id: foodSensorySessionId,
    operator_id: operatorId.nullable(),
    guest_name: z.string().nullable(),
    guest_email: z.string().nullable(),
    token: z.string(),
    status: foodSensoryAnalystStatus,
    consented_at: z.date().nullable(),
    invited_at: z.date().nullable(),
    completed_at: z.date().nullable(),
    seated_at: z.date().nullable(),
    excluded_at: z.date().nullable(),
    excluded_by: operatorId.nullable(),
    taster_id: foodTasterId,
});
export const foodSensoryAnalystInitializer = z.object({
    id: foodSensoryAnalystId.optional(),
    sensory_session_id: foodSensorySessionId,
    operator_id: operatorId.optional().nullable(),
    guest_name: z.string().optional().nullable(),
    guest_email: z.string().optional().nullable(),
    token: z.string().optional(),
    status: foodSensoryAnalystStatus.optional(),
    consented_at: z.date().optional().nullable(),
    invited_at: z.date().optional().nullable(),
    completed_at: z.date().optional().nullable(),
    seated_at: z.date().optional().nullable(),
    excluded_at: z.date().optional().nullable(),
    excluded_by: operatorId.optional().nullable(),
    taster_id: foodTasterId,
});
export const foodSensoryAnalystMutator = z.object({
    id: foodSensoryAnalystId.optional(),
    sensory_session_id: foodSensorySessionId.optional(),
    operator_id: operatorId.optional().nullable(),
    guest_name: z.string().optional().nullable(),
    guest_email: z.string().optional().nullable(),
    token: z.string().optional(),
    status: foodSensoryAnalystStatus.optional(),
    consented_at: z.date().optional().nullable(),
    invited_at: z.date().optional().nullable(),
    completed_at: z.date().optional().nullable(),
    seated_at: z.date().optional().nullable(),
    excluded_at: z.date().optional().nullable(),
    excluded_by: operatorId.optional().nullable(),
    taster_id: foodTasterId.optional(),
});
//# sourceMappingURL=FoodSensoryAnalyst.js.map